module.exports = __webpack_public_path__ + "static/internamento_1-8da2af78cf7a541a46d4bd3e6cbfcfd3.jpg";